import { useCallback } from "react";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";

export const useCreateVendor = () => {
  return usePost(`/users/vendor/create`);
};

export const useGetVendors = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/vendors${queryData}`);
  return data;
};

export const useGetVendorData = (vendorId: number) => {
  return useGet(vendorId ? `/users/vendors/${vendorId}` : null);
};

export const useUpdateVendor = (vendorId: number) => {
  return usePatch(`/users/vendors/${vendorId}`);
};

export const useDeleteVendor = () => {
  const deleteData = useCallback((vendorId: number) => {
    return deleteReq(`/users/vendors/${vendorId}`);
  }, []);
  return useFetchAsync(deleteData);
};

export const useGetProducts = (vendorId: number | undefined) => {
  const data = useGet(vendorId ? `/users/vendors/${vendorId}/products` : null);
  return data;
};

export const useCreateProcurementRequest = (vendorId: number | undefined) => {
  return usePost(vendorId ? `/users/vendors/${vendorId}/create-pr` : null);
};
